export const environment = {
    production: false,
    apiUrl: 'https://api.le-dressing.preprod-s4.cawita.com',
    assetUrl: 'https://assets.le-dressing.preprod-s4.cawita.com',
    customerSpaceUrl: 'https://share.le-dressing.preprod-s4.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR'
};